import React from 'react';
import SbEditable from 'storyblok-react';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';
// import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import styled from 'styled-components';

const Gradient = styled.div`
  background: linear-gradient(26deg, #4b3cf9, #6053fb, #3726fa, #6456fb, #a386e2, #6f4ad8);
  background-size: 1200%;
  animation: GradientBackground 10s ease infinite;

  @keyframes GradientBackground {
    0% {
      background-position: 0% 50%;
    }

    50% {
      background-position: 100% 50%;
    }

    100% {
      background-position: 0% 50%;
    }
  } ;
`;

function TwoColCustomerSlider({ blok }) {
  SwiperCore.use([Autoplay, Pagination, Navigation]);

  return (
    <div>
    <SbEditable content={blok} key={blok._uid}>
      <div className="w-full md:max-w-[450px]">
        <Gradient className="text-white font-heading font-extrabold uppercase">
          <div className="px-10 py-16">
            {blok.slides.map((slide) => (
              <SbEditable content={slide} key={slide._uid}>
                <h5 className="text-16px mb-4">{slide.subheading}</h5>
                <h3 className="text-30px lg:text-[43px] leading-none mb-16">
                  {slide.heading}
                </h3>
                <h5 className="text-16px mb-12">{slide.bottomHeading}</h5>
              </SbEditable>
            ))}
            {blok.slides.length > 1 &&
              <div className="progress grid grid-cols-3 gap-4 max-w-[250px]">
                {blok.slides.map((slide, i) => (
                  <div key={`slide-nav${i}`} className="h-[1px] w-full bg-white" />
                ))}
              </div>
            }
          </div>
        </Gradient>
      </div>
    </SbEditable>
    </div>
  );
}

export default TwoColCustomerSlider;
